/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '../shared/assets/css/inline-edit-common.scss.shim.ngstyle';
import * as i1 from './custom-editor.component.scss.shim.ngstyle';
import * as i2 from '@angular/core';
import * as i3 from '@angular/common';
import * as i4 from '../../../../../../../../src/app/components/shared/inline-edit/components/custom-editor/custom-editor.component';
const styles_CustomEditorComponent:any[] = [i0.styles,i1.styles];
export const RenderType_CustomEditorComponent:i2.RendererType2 = i2.ɵcrt({encapsulation:0,
    styles:styles_CustomEditorComponent,data:{}});
function View_CustomEditorComponent_1(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵeld(0,(null as any),(null as any),7,'p',[['class',
      'actions m-top-10 m-bottom-10']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i2.ɵted((null as any),['\n		'])),(_l()(),i2.ɵeld(0,(null as any),
      (null as any),1,'span',[['class','text-center cp m-right-5']],(null as any),
      [[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.onSaveClick()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i2.ɵted((null as any),['Save'])),(_l()(),
      i2.ɵted((null as any),['\n		'])),(_l()(),i2.ɵeld(0,(null as any),(null as any),
      1,'span',[['class','text-center cp']],(null as any),[[(null as any),'click']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.onCancelClick()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i2.ɵted((null as any),['Cancel'])),(_l()(),
      i2.ɵted((null as any),['\n	']))],(null as any),(null as any));
}
export function View_CustomEditorComponent_0(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[i2.ɵqud(402653184,1,{editorElm:0}),(_l()(),i2.ɵeld(0,(null as any),
      (null as any),6,'div',[['class','custom-editor-wrapper']],[[2,'hidden',(null as any)]],
      (null as any),(null as any),(null as any),(null as any))),(_l()(),i2.ɵted((null as any),
      ['\n	'])),(_l()(),i2.ɵeld(0,[[1,0],['editorElm',1]],(null as any),0,'textarea',
      [['class','form-control']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i2.ɵted((null as any),['\n	'])),(_l()(),i2.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_CustomEditorComponent_1)),i2.ɵdid(16384,
      (null as any),0,i3.NgIf,[i2.ViewContainerRef,i2.TemplateRef],{ngIf:[0,'ngIf']},
      (null as any)),(_l()(),i2.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i4.CustomEditorComponent = _v.component;
    const currVal_1:any = _co.showActions;
    _ck(_v,6,0,currVal_1);
  },(_ck,_v) => {
    var _co:i4.CustomEditorComponent = _v.component;
    const currVal_0:any = (_co.state === 'passive');
    _ck(_v,1,0,currVal_0);
  });
}
export function View_CustomEditorComponent_Host_0(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵeld(0,(null as any),(null as any),1,'inline-edit-custom-editor',
      ([] as any[]),(null as any),(null as any),(null as any),View_CustomEditorComponent_0,
      RenderType_CustomEditorComponent)),i2.ɵdid(770048,(null as any),0,i4.CustomEditorComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const CustomEditorComponentNgFactory:i2.ComponentFactory<i4.CustomEditorComponent> = i2.ɵccf('inline-edit-custom-editor',
    i4.CustomEditorComponent,View_CustomEditorComponent_Host_0,{data:'data',state:'state',
        fingerprint:'fingerprint',height:'height',showActions:'showActions'},{onSave:'onSave',
        onChange:'onChange',onCancel:'onCancel'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL3NoYXJlZC9pbmxpbmUtZWRpdC9jb21wb25lbnRzL2N1c3RvbS1lZGl0b3IvY3VzdG9tLWVkaXRvci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9ub2RlL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvc2hhcmVkL2lubGluZS1lZGl0L2NvbXBvbmVudHMvY3VzdG9tLWVkaXRvci9jdXN0b20tZWRpdG9yLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL3NoYXJlZC9pbmxpbmUtZWRpdC9jb21wb25lbnRzL2N1c3RvbS1lZGl0b3IvY3VzdG9tLWVkaXRvci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL3NoYXJlZC9pbmxpbmUtZWRpdC9jb21wb25lbnRzL2N1c3RvbS1lZGl0b3IvY3VzdG9tLWVkaXRvci5jb21wb25lbnQudHMuQ3VzdG9tRWRpdG9yQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cImN1c3RvbS1lZGl0b3Itd3JhcHBlclwiIFtjbGFzcy5oaWRkZW5dPVwic3RhdGUgPT09ICdwYXNzaXZlJ1wiPlxuXHQ8dGV4dGFyZWEgY2xhc3M9XCJmb3JtLWNvbnRyb2xcIiAjZWRpdG9yRWxtPjwvdGV4dGFyZWE+XG5cdDxwIGNsYXNzPVwiYWN0aW9ucyBtLXRvcC0xMCBtLWJvdHRvbS0xMFwiICpuZ0lmPVwic2hvd0FjdGlvbnNcIj5cblx0XHQ8c3BhbiBjbGFzcz1cInRleHQtY2VudGVyIGNwIG0tcmlnaHQtNVwiIChjbGljayk9XCJvblNhdmVDbGljaygpXCI+U2F2ZTwvc3Bhbj5cblx0XHQ8c3BhbiBjbGFzcz1cInRleHQtY2VudGVyIGNwXCIgKGNsaWNrKT1cIm9uQ2FuY2VsQ2xpY2soKVwiPkNhbmNlbDwvc3Bhbj5cblx0PC9wPlxuPC9kaXY+IiwiPGlubGluZS1lZGl0LWN1c3RvbS1lZGl0b3I+PC9pbmxpbmUtZWRpdC1jdXN0b20tZWRpdG9yPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0VDO01BQUE7TUFBQSxnQkFBNEQseUNBQzNEO01BQUE7TUFBQTtRQUFBO1FBQUE7UUFBdUM7VUFBQTtVQUFBO1FBQUE7UUFBdkM7TUFBQSxnQ0FBK0QseUNBQVc7YUFBQSwwQkFDMUU7TUFBQTtNQUFBO1FBQUE7UUFBQTtRQUE2QjtVQUFBO1VBQUE7UUFBQTtRQUE3QjtNQUFBLGdDQUF1RCwyQ0FBYTthQUFBOzs7dURBSnRFO01BQUE7TUFBQSwwREFBd0U7TUFBQSxVQUN2RTtNQUFBO01BQUEsZ0JBQXFELHdDQUNyRDtNQUFBLGtGQUFBO01BQUE7TUFBQSxlQUdJOztJQUhvQztJQUF4QyxXQUF3QyxTQUF4Qzs7O0lBRmtDO0lBQW5DLFdBQW1DLFNBQW5DOzs7O29CQ0FBO01BQUE7c0NBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./compiled/src/app/components/shared/inline-edit/components/custom-editor/custom-editor.component.ngfactory.ts